module.exports = __webpack_public_path__ + "img/banner_majorsys.cd87a519.png";